import React, { useState, useCallback } from 'react';
import AuthFooter from './Auth-Footer';
import AuthHeader from './Auth-Header';
import { Route } from 'react-router-dom';
import './Auth.scss';

const AuthLayout = ({ component: Component, showProfile, ...rest }) => {
  const [hideProfileForMfa, setHideProfileForMfa] = useState(false);
  const [mfaLogoutCallback, setMfaLogoutCallback] = useState(null);

  const handleMfaStateChange = useCallback((isInMfaFlow, resetCallback) => {
    setHideProfileForMfa(isInMfaFlow);
    setMfaLogoutCallback(() => resetCallback);
  }, []);

  return (
    <div className='auth d-flex align-content-around flex-column vh-100'>
      <AuthHeader 
        showProfile={showProfile && !hideProfileForMfa} 
        mfaLogoutCallback={mfaLogoutCallback}
      />
      <Route
        {...rest}
        render={(props) => (
          <div className='col mb-auto'>
            <Component 
              {...rest} 
              {...props} 
              showProfile={showProfile} 
              onMfaStateChange={handleMfaStateChange}
            />
          </div>
        )}
      ></Route>
      <AuthFooter />
    </div>
  );
};

export default AuthLayout;
